import { CalendarCheck, Phone } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useSite } from "@/context/SiteContext";
import { telHref, waHref } from "@/lib/contact";
import { btn } from "@/lib/ui";
import { cn } from "@/lib/utils";
import { WhatsAppIcon } from "@/components/brand/WhatsAppIcon";

const Option = ({ href, icon, title, sub, testid, external, iconClass }) => (
  <a
    href={href}
    data-testid={testid}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="flex items-center gap-3 rounded-xl px-3 py-3 transition-colors hover:bg-brand-tint focus-visible:bg-brand-tint"
  >
    <span className={cn("flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white", iconClass)}>{icon}</span>
    <span>
      <span className="block font-semibold text-brand-ink">{title}</span>
      <span className="block text-sm text-slate-600">{sub}</span>
    </span>
  </a>
);

export const BookAppointment = ({ testid = "book-appointment", className = "", size = "md", label = "Book Appointment", align = "end" }) => {
  const { settings } = useSite();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`${testid}-btn`} className={cn(btn("blue", size), className)}>
          <CalendarCheck className="h-4 w-4" aria-hidden="true" />
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent align={align} sideOffset={10} className="w-[19rem] rounded-2xl p-2 shadow-xl" data-testid={`${testid}-menu`}>
        <p className="px-3 pb-1 pt-2 text-sm text-slate-600">Book by phone or WhatsApp · {settings.hours_note}</p>
        <Option
          href={telHref(settings)}
          testid={`${testid}-call-option`}
          icon={<Phone className="h-4 w-4" />}
          iconClass="bg-brand-blue"
          title={`Call ${settings.phone_display}`}
          sub="Speak to the clinic"
        />
        <Option
          href={waHref(settings)}
          external
          testid={`${testid}-whatsapp-option`}
          icon={<WhatsAppIcon className="h-5 w-5" />}
          iconClass="bg-brand-wa"
          title="WhatsApp"
          sub="Send us a message to book"
        />
      </PopoverContent>
    </Popover>
  );
};
